import React from 'react';
import { useSupportChat } from '../../contexts/SupportChatContext';

const ChatFAB: React.FC = () => {
  const { isOpen, toggle, unreadCount } = useSupportChat();

  if (isOpen) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Открыть AI помощника"
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        width: 56,
        height: 56,
        borderRadius: '50%',
        background: 'var(--primary-600)',
        border: 'none',
        color: 'var(--surface-1, white)',
        cursor: 'pointer',
        boxShadow: 'var(--shadow-lg)',
        zIndex: 1030,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        transition: 'background 0.15s, transform 0.15s',
        animation: unreadCount > 0 ? 'supportChatFabBounce 0.5s ease' : undefined,
      }}
      onMouseEnter={e => {
        (e.currentTarget as HTMLElement).style.background = 'var(--primary-700)';
        (e.currentTarget as HTMLElement).style.transform = 'scale(1.05)';
      }}
      onMouseLeave={e => {
        (e.currentTarget as HTMLElement).style.background = 'var(--primary-600)';
        (e.currentTarget as HTMLElement).style.transform = 'scale(1)';
      }}
    >
      ✦
      {unreadCount > 0 && (
        <span className="absolute rounded-full text-11 font-bold flex items-center justify-center" style={{ top: -2, right: -2, minWidth: 18, height: 18, background: 'var(--error-500)', color: 'var(--surface-1, white)', padding: '0 4px', border: '2px solid white' }}>
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
};

export default ChatFAB;
